export enum PaymentMethodType {
  PIX = 'PIX',
  DebitoAVista = 'DebitoAVista',
  CreditoAVista = 'CreditoAVista',
  CreditoParcelado = 'CreditoParcelado',
}

export interface PaymentCalculationRequest {
  baseAmount: number;
  paymentMethod: PaymentMethodType;
  installments: number;
  currencyCode: string;
  establishmentSupportsFinancingCosts: boolean;
}

export interface PaymentCalculationResponse {
  value: number;
  paymentMethod: PaymentMethodType;
  currencyCode: string;
  usedExchangeRate: number;
  totalValue: number;
  totalValueBRL: number;
  installments: number;
  installmentValueBRL: number;
  processingFee: number;
  processingCostBRL: number;
  estimatedExchangeCostBRL: number;
  antecipationFee: number;
  maxAntecipationCostBRL: number;
}
